import { ContactMap, ContactInfo } from "./components";
import { useTranslation } from "../../components/Translation";

export default function ContactSection() {
  const { t } = useTranslation();

  return (
    <section className="bg-gray-50 min-h-screen">
      {/* Page header */}
      <div className="bg-white border-b border-gray-200 px-8 py-10">
        <div className="max-w-4xl">
          <span className="inline-block bg-dorado-uady/10 text-dorado-uady text-micro font-bold uppercase px-3 py-1 rounded mb-4">
            {t("contact.badge")}
          </span>

          <h1 className="text-4xl font-bold text-azul-uady mb-3">
            {t("contact.title")}
          </h1>

          <p className="text-mini text-gray-500 max-w-lg">
            {t("contact.description")}
          </p>
        </div>
      </div>

      {/* Map */}
      <div className="relative">
        <ContactMap />
      </div>

      {/* Info + form */}
      <ContactInfo />
    </section>
  );
}